var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4719 1C15.1839 1 16.9999 2.904 16.9999 5.736V12.2728C16.9999 15.096 15.1839 17 12.4719 17H5.53594C2.82394 17 0.999939 15.096 0.999939 12.2728V5.736C0.999939 2.904 2.82394 1 5.53594 1H12.4719ZM12.3439 6.6C12.0719 6.328 11.6239 6.328 11.3519 6.6L8.04794 9.904L6.64794 8.504C6.37594 8.232 5.92794 8.232 5.65594 8.504C5.38394 8.776 5.38394 9.216 5.65594 9.496L7.55994 11.392C7.69594 11.528 7.87194 11.592 8.04794 11.592C8.23194 11.592 8.40794 11.528 8.54394 11.392L12.3439 7.592C12.6159 7.32 12.6159 6.88 12.3439 6.6Z",
    fill: "#0FA44A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b6dacd65.svg";
export { ForwardRef as ReactComponent };